module.exports = __webpack_public_path__ + "static/media/viewgraphic.ae747b54.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Help/assets/viewgraphic.png
// module id = 1858
// module chunks = 193